import { loadAsyncComponent } from 'src/components/AsyncComponent';

export default loadAsyncComponent(() => import('./Container'), 'page');
